import { FamilyCoexistence } from 'shell/models/person/family';
import { Generality } from 'shell/models/person/generality';
import {
  ControlData,
  RequestSubscriptionBirth,
} from 'subscription/models/request-subscription-birth';
import {
  transformAllegati,
  transformDatiControlloAire,
  transformFamiglia,
  transformGeneralita1001,
  transformLegameSoggetto,
  transformResidenzaEstera,
} from './common-request-transformer';
import { SubscriptionTransferOtherMunicipalityFormVM } from 'subscription/view-models/subscription-transfer-other-municipality';

/**
 * Transforms a SubscriptionTransferOtherMunicipalityFormVM into a RequestSubscriptionBirth object.
 * @param {SubscriptionTransferOtherMunicipalityFormVM} values
 * @param {string} [idSchedaSoggettoANPR] idSchedaSoggettoANPR
 * @returns {RequestSubscriptionBirth}
 */
export const transformerRequestSubscriptionTransferAireData = (
  values: SubscriptionTransferOtherMunicipalityFormVM,
  idSchedaSoggettoANPR?: string
): RequestSubscriptionBirth => {
  const famiglia: FamilyCoexistence | undefined = values.familyCoexistence
    ? transformFamiglia(values.familyCoexistence)
    : undefined;

  const datiControllo: ControlData = transformDatiControlloAire(values.editDataControl);

  const generalita: Generality =
    transformGeneralita1001(values.generality, values.civilStatus, idSchedaSoggettoANPR)
      ?.generalita || undefined;

  const residenzaEstera = transformResidenzaEstera(values.addressForeign);

  const legameSoggetto = transformLegameSoggetto(values.familyCoexistence);

  const allegati = transformAllegati(values.document);

  return {
    testataRichiesta: {
      dataDecorrenza: values.editDataControl?.dateValidity
        ? values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd')
        : undefined,
    },
    // altraCittadinanza,
    famiglia,
    datiControllo: {
      ...(datiControllo || {}),
      gestioneCF: undefined,
    },
    generalita,
    residenzaEstera,
    legameSoggetto,
    allegati,
  };
};
